import { Injectable } from '@angular/core';
import {
    CanActivate, Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    CanActivateChild,
    CanLoad, Route, CanMatch, UrlTree
} from '@angular/router';
import {AUTH_ERROR_CODES, AuthService} from '../../../services/auth.service';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad, CanMatch {

    constructor(private authService: AuthService, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let result = this.checkAuthForUrl(state.url);

        if (!environment.production) {
            console.log('(AuthGuard) Can activate: ' + state.url + ' ? -> ' + result);
        }
        return result;

    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let result = this.canActivate(route, state);
        if (!environment.production) {
            console.log('(AuthGuard) Can activate child of: ' + state.url + ' ? -> ' + result);
        }
        return result;

    }

    canLoad(route: Route): boolean {
        let result = this.checkAuthForUrl(`/${route.path}`);
        if (!environment.production) {
            console.log('(AuthGuard) Can load: /' + route.path + ' (match: ' + route.pathMatch + ') ? -> ' + result);
        }
        return result;

    }

    checkAuthForUrl(url: string): boolean {

        let authenticated: boolean;

        try {
            authenticated = this.authService.isAuthenticated();
        } catch (e) {
            console.warn(e, 'URL: ' + url);

            if (url === '/' || url === '/r') {
                this.router.navigate([ '/login' ]);
            } else {
                this.router.navigate([ '/login', { errorCode: e.errorCode || AUTH_ERROR_CODES.UNKNOWN_ERROR, url: url } ]);
            }

            return false;
        }

        return authenticated;

    }

    canMatch(route: Route): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        let result = this.checkAuthForUrl(`/${route.path}`);
        if (!environment.production) {
            console.log('(AuthGuard) Can match: /' + route.path + ' (match: ' + route.pathMatch + ') ? -> ' + result);
        }
        return result;
    }
}
